import { ICON_COLLECTION } from 'assets/media/icons';
import Icon from 'common/components/base/icon';

import './DeleteIconCellRenderer.scss';

type DeleteIconCellRendererProps = {
    data: any;
    onDelete: (data: any) => void;
    isActionDisabled: boolean;
};

export default function DeleteIconCellRenderer({
    data,
    onDelete,
    isActionDisabled = false
}: DeleteIconCellRendererProps) {
    return (
        <span
            className={
                isActionDisabled ? 'delete-icon-container-disabled' : 'delete-icon-container'
            }
            title="Delete"
            onClick={() => (isActionDisabled ? null : onDelete(data))}>
            <Icon className="action-icon" src={ICON_COLLECTION.IC_Delete} />
        </span>
    );
}
